import React from 'react'
import {Calculator} from 'lucide-react'

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-16" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Calculator className="w-6 h-6 text-blue-400" aria-hidden="true" />
              <span className="text-xl font-bold text-white">SAT Scores Calculator</span>
            </div>
            <p className="text-sm text-gray-400">
              Your free, accurate tool to calculate SAT scores, convert ACT to SAT, 
              and track your test preparation progress.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-blue-400 transition-colors">
                  Digital SAT Calculator
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-400 transition-colors">
                  ACT to SAT Conversion
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-400 transition-colors">
                  Practice Test Calculator
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-400 transition-colors">
                  Score Conversion Tables
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-blue-400 transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-400 transition-colors">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-blue-400 transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-gray-400 text-center">
          <p className="mb-2">
            © {new Date().getFullYear()} SAT Scores Calculator. All rights reserved.
          </p>
          <p className="text-xs">
            <strong>Disclaimer:</strong> This website is not affiliated with, endorsed by, or connected to the College Board. 
            SAT® is a registered trademark of the College Board, which does not sponsor or endorse this site. 
            Score estimates are based on official conversion tables but actual test scores may vary.
          </p>
        </div>
      </div>
    </footer>
  )
}
